<p-dialog
  [visible]="!!splitter"
  (visibleChange)="!$event && closed.emit()"
  [modal]="true"
  [draggable]="false"
  [maximizable]="true"
  appendTo="body"
  [style]="dialogStyle"
  [breakpoints]="dialogBreakpoints"
>
  <ng-template pTemplate="header">
    <span class="flex items-center gap-2.5 text-xl font-bold">
      <app-odb-icon class="h-9 w-8" />
      Splitter: {{ name }}
    </span>
  </ng-template>
  @if (splitter) {
  <app-onu-splitter
    [view]="splitter"
    (openOnu)="openOnu.emit($event)"
    (changed)="changed.emit()"
    (closed)="closed.emit()"
  />
  }
</p-dialog>
